export const DEFAULT_ENROLLMENT_PATH = '/sponsored-enroll'

export const enrollmentPaths = {
  resume: '/resume/$token',
  resumePrefix: '/resume/',
  signatureReturn: '/signature-return',
  sponsoredEnroll: '/sponsored-enroll',
} as const

export const enrollmentRoutePrefixes = [
  enrollmentPaths.sponsoredEnroll,
  enrollmentPaths.signatureReturn,
  enrollmentPaths.resumePrefix,
] as const
